import "./langElement.css"

export function Langelement({ activeLang, setActiveLang, languages, lang }) {
    return (
        <div className={`d-flex align-items-center gap-2 lang-elm ${activeLang === lang ? "on " : ""}`}
            onClick={() => setActiveLang(lang)}>
            <img
                src={`/images/${languages[lang].flag}`}
                width={20}
                height={15}
                alt=""
            />
            <div>{languages[lang].text}</div>
        </div>
    )
}